<template>
  <div class="draft-exam-composer" @keydown.enter.prevent>
    <div v-if="modelValue.length" class="exam-list mb-4">
      <div v-for="(exam, index) in modelValue" :key="exam.id_exam" class="exam-item">
        <span class="exam-item-index">{{ index + 1 }}</span>
        <div class="exam-item-body">
          <div class="exam-item-top">
            <span class="exam-item-name">{{ exam.exam_name }}</span>
            <div class="exam-item-aside">
              <span v-if="exam.exam_tuss_code" class="exam-item-tuss">TUSS {{ exam.exam_tuss_code }}</span>
              <button type="button" class="btn btn-icon btn-sm btn-bg-light btn-active-color-primary"
                      title="Excluir exame" @click="remove(index)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <label class="form-label">Adicionar exame</label>
    <InputSearchExam v-model="search" @onSetSearchExam="addExam"/>
    <small class="text-muted d-block mt-2">
      Escolha na busca para incluir. Pode adicionar quantos precisar antes de cadastrar.
    </small>
  </div>
</template>

<script>
import Alert from "@/helpers/alert";
import InputSearchExam from "@/components/InputSearchExam.vue";

export default {
  name: "DraftExamComposer",
  components: {InputSearchExam},
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    addExam(exam) {
      if (!exam?.id_exam) {
        return;
      }
      if (this.modelValue.some((item) => item.id_exam === exam.id_exam)) {
        Alert.toastWarning('Este exame já está no pedido.');
        this.search = '';
        return;
      }

      this.$emit('update:modelValue', [...this.modelValue, {
        id_exam: exam.id_exam,
        exam_name: exam.exam_name,
        exam_tuss_code: exam.exam_tuss_code,
      }]);
      this.search = '';
    },
    remove(index) {
      const next = this.modelValue.slice();
      next.splice(index, 1);
      this.$emit('update:modelValue', next);
    },
    reset() {
      this.search = '';
    },
  },
};
</script>

<style scoped>
.exam-list {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.exam-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
}

.exam-item + .exam-item {
  border-top: 1px solid #eef0f2;
}

.exam-item-index {
  flex-shrink: 0;
  width: 18px;
  padding-top: 2px;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.4;
  text-align: right;
}

.exam-item-body {
  flex: 1;
  min-width: 0;
}

.exam-item-top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.exam-item-name {
  font-weight: 600;
  color: #212529;
  line-height: 1.35;
}

.exam-item-aside {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.exam-item-tuss {
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f3f5;
  color: #495057;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
</style>
